/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Status_PlannedInputs */

const en_us2_community_status_planned = /** @type {(inputs: Community_Status_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planned`)
};

const pt_br2_community_status_planned = /** @type {(inputs: Community_Status_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planejado`)
};

const es_419_community_status_planned = /** @type {(inputs: Community_Status_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planeado`)
};

const pt_pt2_community_status_planned = /** @type {(inputs: Community_Status_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planeado`)
};

const fr_fr2_community_status_planned = /** @type {(inputs: Community_Status_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prévu`)
};

const de_de2_community_status_planned = /** @type {(inputs: Community_Status_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geplant`)
};

const it_it2_community_status_planned = /** @type {(inputs: Community_Status_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pianificato`)
};

/**
* | output |
* | --- |
* | "Planned" |
*
* @param {Community_Status_PlannedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_status_planned = /** @type {((inputs?: Community_Status_PlannedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Status_PlannedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_status_planned(inputs)
	if (locale === "es-419") return es_419_community_status_planned(inputs)
	if (locale === "pt-PT") return pt_pt2_community_status_planned(inputs)
	if (locale === "fr-FR") return fr_fr2_community_status_planned(inputs)
	if (locale === "de-DE") return de_de2_community_status_planned(inputs)
	if (locale === "it-IT") return it_it2_community_status_planned(inputs)
	return en_us2_community_status_planned(inputs)
});
export { community_status_planned as "community.status_planned" }